module.exports = __webpack_public_path__ + "static/media/redux.51740744.svg";